var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTkLegendA4En(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a4",
    width: "297mm",
    height: "210mm",
    viewBox: "0 0 841.89 595.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "rect2",
    d: "M0 0h841.89v595.276H0z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "rand",
    transform: "translate(-1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1034",
    d: "M73.058 551h522.593c.868 0 1.57.816 1.57 1.823v22.881c0 1.007-.703 1.823-1.57 1.823H73.058Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text20852",
    x: 76.944,
    y: 558.357,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 5,
      lineHeight: 1,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan82578",
    x: 76.944,
    y: 558.357
  }, "On certain bus routes, a supplement and/or seat reservation is required. Please also note that a bike space reservation is mandatory for bicycles on InterCity (IC) trains from 21 March to 31 October. Please note the information for the")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan82580",
    x: 76.944,
    y: 563.357
  }, "desired connection in the (online) timetable. Depending on the zoom level, not all lines shown due to lack of space. All information without guarantee. Subject to change. The scope of application applies."))), /*#__PURE__*/React.createElement("text", {
    id: "text493",
    x: 76.722,
    y: 572.645,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 5,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan88022",
    x: 76.722,
    y: 572.645
  }, "Source: OpenStreetMap contributors \xA9 SBB/CFF/FFS www.tra\uFB01mage.ch www.geops.ch")))), /*#__PURE__*/React.createElement("g", {
    id: "qr-code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect23865",
    d: "M17.008 527.244h51.024v51.024H17.008Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68822",
    d: "M18.466 528.702h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm9.102 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm-46.806 1.3h1.3v1.3h-1.3zm7.801 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm5.2 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm7.802 0h1.3v1.3h-1.3zm-46.807 1.3h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm-46.806 1.3h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm-46.806 1.3h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm5.2 0h1.301v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm3.9 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm6.501 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.301v1.301h-1.3zm-46.806 1.3h1.3v1.301h-1.3zm7.801 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm2.6 0h1.301v1.301h-1.3zm6.502 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm5.201 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm5.2 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm7.802 0h1.3v1.301h-1.3zm-46.807 1.301h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm-31.204 1.3h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm-36.405 1.3h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm-45.506 1.3h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm11.703 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm-41.605 1.3h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm5.2 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.9 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm5.201 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.301v1.301h-1.3zm-46.806 1.301h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm6.502 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm-45.506 1.3h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm-45.506 1.3h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm6.502 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm6.502 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm-37.705 1.3h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm6.502 0h1.3v1.3h-1.3zm6.5 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm-45.506 1.3h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.9 0h1.301v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.301v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm6.5 0h1.301v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm3.9 0h1.301v1.301h-1.3zm-45.506 1.301h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm-46.806 1.3h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm-45.506 1.3h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm-46.806 1.3h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm-41.605 1.3h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm3.9 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm6.501 0h1.3v1.301h-1.3zm3.9 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm-44.206 1.301h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm9.102 0h1.3v1.3h-1.3zm-45.507 1.3h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm7.802 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm-45.506 1.3h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm9.102 0h1.3v1.3h-1.3zm-46.807 1.3h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm-46.806 1.3h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm6.5 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm3.9 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm-45.507 1.3h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.9 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm-46.806 1.301h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm7.802 0h1.3v1.3h-1.3zm7.8 0h1.301v1.3h-1.3zm-46.806 1.3h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm-33.804 1.3h1.3v1.3h-1.3zm5.2 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm5.201 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm5.201 0h1.3v1.3h-1.3zm-41.606 1.3h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm5.202 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm7.801 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm5.201 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm-46.806 1.3h1.3v1.301h-1.3zm7.801 0h1.3v1.301h-1.3zm3.9 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm5.201 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm6.5 0h1.301v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm5.201 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm-45.506 1.301h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm5.201 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm-45.506 1.3h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm5.201 0h1.3v1.3h-1.3zm3.901 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm-46.806 1.3h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm6.502 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm1.3 0h1.301v1.3h-1.3zm-46.806 1.3h1.3v1.3h-1.3zm7.801 0h1.3v1.3h-1.3zm2.6 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm2.601 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm7.802 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm6.501 0h1.3v1.3h-1.3zm1.3 0h1.3v1.3h-1.3zm3.9 0h1.301v1.3h-1.3zm1.301 0h1.3v1.3h-1.3zm5.2 0h1.301v1.3h-1.3zm-46.806 1.3h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm2.6 0h1.301v1.301h-1.3zm1.301 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm3.9 0h1.301v1.301h-1.3zm2.601 0h1.3v1.301h-1.3zm6.501 0h1.3v1.301h-1.3zm2.6 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3zm3.901 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm5.201 0h1.3v1.301h-1.3zm1.3 0h1.3v1.301h-1.3zm1.3 0h1.301v1.301h-1.3z",
    style: {
      fill: "#000",
      strokeWidth: 0.216698
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "sbb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect22814",
    d: "M628.838 17.008h196.044v22.94H628.838z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect397399",
    d: "M630.289 18.258h192.107v20.659H630.289z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2879",
    d: "M630.289 38.704h60.702V18.47h-60.702v20.234Z",
    style: {
      fill: "#e42328",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2881",
    d: "M666.02 27.039h6.563v-5.196h3.092v5.196h6.563l-5.28-5.196h3.918l6.745 6.744-6.745 6.745h-3.921l5.28-5.196h-6.56v5.196h-3.092v-5.196h-6.563l5.28 5.196h-3.916l-6.745-6.744 6.745-6.745h3.917",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2883",
    d: "M697.255 31.303c-.039 3.492 2.896 5.04 6.03 5.04 3.848 0 5.891-1.944 5.891-4.544 0-3.211-3.173-3.866-4.205-4.122-3.55-.914-4.224-1.053-4.224-2.142 0-1.19 1.149-1.606 2.143-1.606 1.487 0 2.698.435 2.796 2.142h3.015c0-3.272-2.717-4.56-5.672-4.56-2.559 0-5.296 1.388-5.296 4.285 0 2.658 2.122 3.471 4.226 4.025 2.082.555 4.203.814 4.203 2.34 0 1.448-1.666 1.766-2.757 1.766-1.666 0-3.133-.735-3.133-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2885",
    d: "M714.21 24.264h2.916c1.11 0 2.143.277 2.143 1.626 0 1.19-.814 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.74h6.862c2.559 0 5-1.229 5-4.105 0-1.765-.875-3.094-2.6-3.59a3.106 3.106 0 0 0 1.925-2.956c0-2.637-1.825-3.51-4.523-3.51h-6.664v14.162Zm3.114-6.307h3.39c1.329 0 2.241.577 2.241 2.024 0 1.466-1.07 1.864-2.3 1.864h-3.33",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2887",
    d: "M728.148 24.264h2.916c1.11 0 2.142.277 2.142 1.626 0 1.19-.813 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.74h6.861c2.56 0 4.998-1.229 4.998-4.105 0-1.765-.872-3.094-2.598-3.59a3.106 3.106 0 0 0 1.923-2.956c0-2.637-1.823-3.51-4.52-3.51h-6.664v14.162Zm3.115-6.307h3.39c1.33 0 2.242.577 2.242 2.024 0 1.466-1.07 1.864-2.3 1.864h-3.331",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2889",
    d: "M756.674 26.603c-.377-3.272-2.994-5.096-6.108-5.096-4.384 0-6.961 3.273-6.961 7.476 0 4.086 2.577 7.359 6.96 7.359 3.472 0 5.91-2.26 6.228-5.792h-3.016c-.237 1.865-1.308 3.173-3.211 3.173-2.797 0-3.85-2.38-3.85-4.74 0-2.48 1.054-4.86 3.85-4.86 1.545 0 2.896 1.071 3.094 2.479",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2891",
    d: "M758.71 36.005h3.114v-5.851h5.93v-2.42h-5.93v-3.272h6.842v-2.617h-9.956",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2893",
    d: "M770.56 36.005h3.104v-5.851h5.924v-2.42h-5.926v-3.272h6.835v-2.617h-9.938",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2895",
    d: "M787.241 36.005h3.122v-5.851h5.924v-2.42h-5.924v-3.272h6.834v-2.617h-9.956",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2897",
    d: "M799.464 36.005h3.105v-5.851h5.924v-2.42h-5.924v-3.272h6.852v-2.617h-9.957",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2899",
    d: "M810.562 31.303c-.035 3.492 2.89 5.04 6.031 5.04 3.854 0 5.888-1.944 5.888-4.544 0-3.211-3.176-3.866-4.193-4.122-3.55-.914-4.228-1.053-4.228-2.142 0-1.19 1.141-1.606 2.142-1.606 1.48 0 2.695.435 2.801 2.142h2.998c0-3.272-2.712-4.56-5.656-4.56-2.57 0-5.3 1.388-5.3 4.285 0 2.658 2.123 3.471 4.23 4.025 2.07.555 4.192.814 4.192 2.34 0 1.448-1.659 1.766-2.747 1.766-1.678 0-3.14-.735-3.14-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "title"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path513",
    d: "M300.981 55.506H0V17.04h300.977a1.523 1.416 0 0 1 1.525 1.416V54.09c0 .782-.684 1.416-1.523 1.416z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text735",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 12,
      fontFamily: "SBBWeb-Light,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(17.157 32.43)"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan954",
    x: 0,
    y: 0
  }, "Saver Day Pass / Special Day Pass / Municipal Saver")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan956",
    x: 0,
    y: 15
  }, "Day Pass without a valid Half Fare Travelcard")))), /*#__PURE__*/React.createElement("g", {
    id: "legend",
    transform: "translate(0 -16.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect426128-0-8-3-9-2",
    width: 172.59,
    height: 105.259,
    x: 9.457,
    y: 77.632,
    rx: 1.984,
    ry: 1.873,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scaleline",
    transform: "translate(0 -7.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text745",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(62.56 178.12)"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan739",
    x: 0,
    y: 0
  }, "50")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan741",
    x: 8.341,
    y: 0,
    style: {
      letterSpacing: ".00342em"
    }
  }, "k"), _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan743",
    x: 11.476,
    y: 0
  }, "m"))), /*#__PURE__*/React.createElement("path", {
    id: "path1881",
    d: "M125.04 172.298v9.44l-107.434.052v-9.494",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".9031px",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g765",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text751",
    x: 17.075,
    y: 109.62,
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan19534",
    x: 17.075,
    y: 109.62
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan749",
    x: 17.075,
    y: 109.62
  }, "Railways")))), /*#__PURE__*/React.createElement("g", {
    id: "g763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line753",
    d: "M18.29 100.564h27.663",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g783",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text769",
    x: 102.438,
    y: 109.693,
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan767",
    x: 102.438,
    y: 109.693
  }, "Cableways"))), /*#__PURE__*/React.createElement("g", {
    id: "g781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line771",
    d: "M103.358 100.564h27.663",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g826",
    transform: "translate(-42.572 -4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7-1",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text797",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(145.12 146.932)"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan58320",
    x: 0,
    y: 0
  }, "Ask for")), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan58324",
    x: 0,
    y: 7.5
  }, "validity on")), _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan64770",
    x: 0,
    y: 15
  }, "site")))), /*#__PURE__*/React.createElement("g", {
    id: "g824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line818",
    d: "M145.893 137.151v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line820",
    d: "M148.659 137.151h23.514",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line822",
    d: "M173.556 137.151v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g854",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text840",
    x: 145.12,
    y: 109.62,
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, "Boats"), /*#__PURE__*/React.createElement("g", {
    id: "g852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line842",
    d: "M145.893 100.564h27.663",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g892",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text868",
    x: 59.806,
    y: 109.62,
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, "Buses"), /*#__PURE__*/React.createElement("g", {
    id: "g890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line870",
    d: "M61.07 100.564h27.173",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line880",
    d: "M60.824 100.564h27.664",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g925",
    transform: "translate(0 -4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text908",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(17.075 146.933)"
  }, "Free travel")), /*#__PURE__*/React.createElement("g", {
    id: "g923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line911",
    d: "M18.167 125.783h27.664",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line913",
    d: "M18.167 133.361h27.664",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line915",
    d: "M18.168 137.151h27.663",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g921"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line917",
    d: "M18.413 129.572h27.173",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line919",
    d: "M18.167 129.572h27.664",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1036",
    transform: "translate(-42.572 -4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1031",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(102.438 146.933)"
  }, "No reduction")), /*#__PURE__*/React.createElement("path", {
    id: "line1034",
    d: "M103.358 137.151h27.664",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "state-publisher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text2350",
    style: {
      isolation: "isolate"
    },
    transform: "translate(9)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1042",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(41.786 88.501)"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1038",
    x: 0,
    y: 0
  }, "***publishedAt***")))), /*#__PURE__*/React.createElement("g", {
    id: "text2347",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1047",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(17.075 88.501)"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan976",
    x: 0,
    y: 0
  }, "Created on")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTkLegendA4En);
export default __webpack_public_path__ + "static/media/tk_legend_a4_en.f444481a8e89cd8c7fd7c92ec64d2bba.svg";
export { ForwardRef as ReactComponent };